import React from 'react';
import styled from '@benzinga/themetron';

interface FundamentalInfoProps {
  name: string;
  value: string | number | JSX.Element;
}

export const FundamentalInfoDataCell = ({ name, value }: FundamentalInfoProps) => {
  return (
    <td className="fundamental-info">
      <span className="label">{name}</span>
      <span className="value">{value}</span>
    </td>
  );
};

export const FundamentalInfoContainer: React.FC<React.PropsWithChildren> = ({ children }) => (
  <tr className="fundamental-info-container">{children}</tr>
);

export const FundamentalsContainer = styled.table<{ columns?: number; hideDataCell?: number[] }>`
  &.stock-fundamentals,
  &.crypto-fundamentals {
    display: grid;
    grid-template-columns: ${({ columns }) => `repeat(${columns ? columns : 3}, minmax(0, 1fr))`};
    border-radius: 4px;
    border: solid 1px #ddd;
    background-color: #f7f7f7;
    .fundamentals-tbody {
      display: contents;
    }
    .fundamental-info-container {
      border-right: solid 1px #ddd;
      width: 100%;
      max-width: ${({ columns }) => (columns === 2 ? '350px' : '100%')};

      ${({ columns, hideDataCell }) =>
        hideDataCell &&
        columns === 3 &&
        hideDataCell.map(
          cellIndex => `
        td {
          &:nth-of-type(${cellIndex}) {
            display: none;
          }
          &:nth-of-type(${cellIndex - 1}) {
            border-bottom: none;
          }
        }
      `,
        )};

      &:last-of-type {
        border-right: none;
      }
    }
    .fundamental-info {
      border-bottom: solid 1px #ddd;
      padding: 2px 8px;
      font-size: 0.9rem;
      display: flex;
      justify-content: space-between;
      gap: 4px;
      width: 100%;
      .label {
        color: ${({ theme }) => theme.colorPalette.gray800};
      }
      .value {
        color: ${({ theme }) => theme.colorPalette.gray900};
        font-weight: ${({ theme }) => theme.fontWeight.bold};
      }
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
`;
